import { observer } from "mobx-react-lite";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';


const SearchField = observer(({ store, placeholder }: any) => {
    const currentValue = store?.searchValue || '';

    return (
        <div className="p-inputgroup" style={{ width: '100%', position: 'relative' }}>
            <InputText
                placeholder={placeholder || 'Suche'}
                value={currentValue}
                onChange={(e) => store.updateSearch(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        store.onSearch(); // Führe die Suche aus, wenn Enter gedrückt wird
                    } else if (e.key === 'Escape') {
                        store.updateSearch(''); // Lösche den Suchwert, wenn Escape gedrückt wird
                    }
                }}
                style={{ paddingRight: '5rem', flex: 1 }} // Platz für beide Buttons im Input
            />
            <Button
                icon="pi pi-times"
                className="p-button-text p-button-danger"
                onClick={() => store.updateSearch('')}
                aria-label="Löschen"
                style={{
                    position: 'absolute',
                    zIndex: 2,
                    right: '2.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '100%',
                    borderRadius: '0',
                    padding: '0.5rem',
                    visibility: currentValue ? 'visible' : 'hidden', // Sichtbarkeit basierend auf dem Wert
                }}
            />
            <Button
                icon="pi pi-search"
                onClick={() => store.onSearch()} // Führe die Suche aus, wenn der Suchbutton geklickt wird
                aria-label="Suchen"
                style={{
                    position: 'absolute',
                    zIndex: 2,
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '100%',
                    borderRadius: '0',
                    padding: '0.5rem',
                }}
            />
        </div>
    );
});

export default SearchField;